const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export function formatCents(cents) {
  return usd.format(Number(cents) / 100);
}

export function parseMoney(text) {
  const s = String(text ?? '').replace(/[$\s]/g, '');
  if (!/^\d[\d.,]*$/.test(s)) return null;
  const lastSep = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
  let whole = s;
  let frac = '';
  if (lastSep >= 0) {
    const tail = s.slice(lastSep + 1);
    const isDecimal = tail.length <= 2 && (s.split(/[.,]/).length === 2 || s[lastSep] !== s[s.search(/[.,]/)]);
    if (isDecimal) { whole = s.slice(0, lastSep); frac = tail; }
    else if (tail.length !== 3) return null;
  }
  const groups = whole.split(/[.,]/);
  if (groups.length > 1 && (groups.slice(1).some(g => g.length !== 3) || groups[0].length > 3)) return null;
  if (new Set(whole.match(/[.,]/g) || []).size > 1) return null;
  return Number(groups.join('')) * 100 + Number(frac.padEnd(2, '0') || 0);
}
